import React, { useEffect, useState } from 'react';
import { Shield, Menu, X } from 'lucide-react';
export const CALENDAR_LINK = 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2NwUD7HcIUT24zh9qeGUjOev1Y2wagC0nmFUxCRFUDW3GNlgytmWM6Uc3SoWsoehJeFw2Oy1_A?gv=true';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-brand-navy py-5'}`} data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="flex justify-between items-center" data-id="element-69">
          <div className="flex items-center gap-2" data-id="element-70">
            <Shield className={`w-8 h-8 ${isScrolled ? 'text-brand-navy' : 'text-white'}`} data-id="element-71" />
            <span className={`font-bold text-xl tracking-tight ${isScrolled ? 'text-brand-navy' : 'text-white'}`} data-id="element-72">
              Protection & Savings
            </span>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-73">
            <a href="#beneficios" className={`text-sm font-medium hover:text-brand-green transition-colors ${isScrolled ? 'text-gray-600' : 'text-gray-300'}`} data-id="element-74">
              Beneficios
            </a>
            <a href="#como-funciona" className={`text-sm font-medium hover:text-brand-green transition-colors ${isScrolled ? 'text-gray-600' : 'text-gray-300'}`} data-id="element-75">
              Cómo Funciona
            </a>
            <a href="#faq" className={`text-sm font-medium hover:text-brand-green transition-colors ${isScrolled ? 'text-gray-600' : 'text-gray-300'}`} data-id="element-76">
              FAQ
            </a>
            <a href={CALENDAR_LINK} target="_blank" rel="noopener noreferrer" className="bg-brand-green hover:bg-green-700 text-white px-6 py-2.5 rounded-md font-semibold transition-colors shadow-sm" data-id="element-77">
              Conecta con un agente
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-78">
            {mobileMenuOpen ? <X className={`w-6 h-6 ${isScrolled ? 'text-brand-navy' : 'text-white'}`} data-id="element-79" /> : <Menu className={`w-6 h-6 ${isScrolled ? 'text-brand-navy' : 'text-white'}`} data-id="element-80" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100" data-id="element-81">
          <div className="flex flex-col px-4 py-4 space-y-4" data-id="element-82">
            <a href="#beneficios" onClick={() => setMobileMenuOpen(false)} className="text-brand-navy font-medium py-2" data-id="element-83">
              Beneficios
            </a>
            <a href="#como-funciona" onClick={() => setMobileMenuOpen(false)} className="text-brand-navy font-medium py-2" data-id="element-84">
              Cómo Funciona
            </a>
            <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="text-brand-navy font-medium py-2" data-id="element-85">
              FAQ
            </a>
            <a href={CALENDAR_LINK} target="_blank" rel="noopener noreferrer" className="bg-brand-green text-white text-center px-6 py-3 rounded-md font-semibold" data-id="element-86">
              Conecta con un agente
            </a>
          </div>
        </div>}
    </header>;
}